import 'photoswipe/dist/photoswipe.css';
import PhotoSwipe from 'photoswipe';
import PhotoSwipeLightbox from 'photoswipe/lightbox';

document.addEventListener('DOMContentLoaded', function() {
    // Check if the gallery element exists before trying to access its style
    const galleryElement = document.getElementById('gallery--no-dynamic-import');

    // Only proceed if gallery exists
    if (!galleryElement) {
        return;
    }

    // Hide the gallery element
    galleryElement.style.display = 'none';

    // Initialize PhotoSwipe
    const lightbox = new PhotoSwipeLightbox({
        gallery: '#gallery--no-dynamic-import',
        children: 'a',
        pswpModule: PhotoSwipe,
        showHideAnimationType: 'fade',
        preloaderDelay: 4000,
        // Accessibility features
        closeOnVerticalDrag: true,
        mainClass: 'pswp-with-perma-preloader',
        padding: { top: 20, bottom: 40, left: 100, right: 100 },
        returnFocus: true
    });

    // Initialize the lightbox
    lightbox.init();

    // Add click handler to the main image link
    const mainImageLink = document.querySelector('.artist-cover > a.artist-gallery-box');
    if (mainImageLink) {
        mainImageLink.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();

            // Open the first image in the gallery
            lightbox.loadAndOpen(0);

            return false;
        });

        // Add accessibility attributes to the main link
        mainImageLink.setAttribute('role', 'button');
        mainImageLink.setAttribute('tabindex', '0');
        mainImageLink.setAttribute('aria-label', 'Open image gallery');
    }
});